// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCard_root__gvrM5","freeBox":"PlasmicCard_freeBox__GycY0","slotTargetChildren":"PlasmicCard_slotTargetChildren__+VoIg"};